import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { L1TransactionsEdit } from "./edit";
import { L1TransactionsNew } from "./new";
import { L1TransactionsTable } from "./table";

export default function L1Transactions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Transactions");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<L1TransactionsEdit />} />
      <Route index element={<L1TransactionsTable />} />
      <Route path="/new" element={<L1TransactionsNew />} />
    </Routes>
  );
}
